import ContactsAPI from "@/api/ContactsAPI";
import {typeRequestNameForApi, idUserForApi, typesContact} from "@/controllers/UserController";
import store from "@/store";

class ContactsController {
  constructor() {
    this.api = ContactsAPI;
  }


  _checkTypeContact(typeContact) {
    if (!typesContact[typeContact])
      throw new Error('type contact invalid can be founder or region;');
  }

  _checkId(id) {
    if (id === null)
      throw new Error('id cannot be null');
  }

  /**
   * @param { 'founder' | 'region' | 'org'} [typeContact]
   * @param { Number | null| undefined } [id]
   * */
  async getContactController(typeContact, id) {
    if (id) {
      try {
        typeContact = typeContact ?? typeRequestNameForApi(typeContact);
        this._checkId(id);
        this._checkTypeContact(typeContact);
        const res = await this.api.getContact(typeContact, id);
        return res.data
      } catch (e) {
        throw new Error('error getContact ' + e.message)
      }
    }
    // else
    //   throw new Error('error getContact no user ID');
  }

  async getAllContactsController(typeContact) {
    try {
      typeContact = typeContact ?? typeRequestNameForApi(typeContact);
      this._checkTypeContact(typeContact);
      const res = await this.api.getContact(typeContact, '');
      return res.data
    } catch (e) {
      console.error('error getContact ' + e.message)
      throw new Error('error getContact ' + e.message)
    }
  }

  /**
   * @param { 'region' } [typeContact]
   * */
  async getContactsFiles(typeContact) {
    try {
      typeContact = typeContact ?? typeRequestNameForApi(typeContact);
      this._checkTypeContact(typeContact);
      const res = await this.api.getContactFiles(typeContact);
      return res.data
    } catch (e) {
      console.error('error getContactsFiles ' + e.message)
      throw new Error('error getContactsFiles ' + e.message)
    }
  }

  /**
   * @param {{
   *       email: string,
   *       fio: string,
   *       position: string,
   *       workPhoneNumber: string,
   *       workPhoneExtension: string,
   *       personalPhoneNumber: string,
   *       personalPhoneExtension: string,
   *       typeContact: 'MAIN' | 'OTV'
   * }} data
   * @param {'founder'| 'region' | 'org'} [typeContact]
   * */
  async setContact(data, typeContact) {
    try {
      typeContact = typeContact ?? typeRequestNameForApi(typeContact);
      let id = idUserForApi();
      this._checkId(id);
      this._checkTypeContact(typeContact);
      data[typesContact[typeContact]] = {id: id};
      // eslint-disable-next-line no-unused-vars
      const {personalPhoneNumberFormatted, workPhoneNumberFormatted, ...payload} = data;
      const res = await this.api.setContacts(payload, typeContact);
      return res.data;
    } catch (e) {
      await store.dispatch('notifications/addNotification', {
        notificationStatus: 'error',
        notificationMessage: 'ошибка сохранения данных о контакте  ',
        timeout: 3000
      }, {root: true});
      console.error('error setContact ' + e.message)
      throw new Error('error setContact ' + e.message)
    }
  }

  /**
   * @param { Number | null| undefined } [orgId]
   * */
  async getOrganizationContact(orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const res = await this.api.getOrganizationContact(orgId);
      return res.data
    } catch (e) {
      console.error('error getOrganizationContact ' + e.message)
      throw new Error('error getOrganizationContact ' + e.message)
    }
  }

  /**
   * @param {   {
   *     "id": number,
   *     "dateCreateDate": Date,
   *     "dateUpdateDate": Date,
   *     "firstName": string,
   *     "secondName": string,
   *     "lastName": string,
   *     "position": string,
   *     "firstNameRP": string,
   *     "secondNameRP": string,
   *     "lastNameRP": string,
   *     "positionRP": string,
   *     "workPhoneNumber": string,
   *     "workPhoneExtension": string,
   *     "personalPhoneNumber": string,
   *     "personalPhoneExtension": string,
   *     "email": string,
   *     "typeContact": string,
   *     "orgId": number,
   *     "userGroup": string,
   *     "userUuid": string,
   *     "userId": number
   *   }} data
   * */
  async setOrganizationContact(data) {
    try {
      let orgId = idUserForApi();
      this._checkId(orgId);
      const payload = {...data, orgId}
      const res = await this.api.setOrganizationContact(payload);
      return res.data
    } catch (e) {
      console.error('error setOrganizationContact ' + e.message)
      throw new Error('error setOrganizationContact ' + e.message)
    }
  }

  /**
   * @param { Number | null| undefined } [id]
   * */
  async deleteOrganizationContact(id) {
    try {
      this._checkId(id);
      const res = await this.api.deleteOrganizationContact(id);
      return res.data
    } catch (e) {
      console.error('error deleteOrganizationContact ' + e.message)
      throw new Error('error deleteOrganizationContact ' + e.message);
    }
  }
}

export default new ContactsController();